import { useRouter } from 'next/router';

import UserNotFoundModal from '../../components/_organisms/UserNotFoundModal';
import { newRelicNoticeError } from '../../hooks/useNewRelic';
import useSignIn from '../../hooks/useSignIn';
import { AuthenticationError, AuthError, AuthErrorType } from '../../types/auth';
import { readPostAuthRedirect } from '../../utils/postAuthRedirect';

const AuthErrorPage = () => {
  const router = useRouter();
  const { signIn } = useSignIn();

  // Parse generic error from query parameters
  const errorType = router.query.error_type as AuthErrorType;
  const errorMessage = router.query.error_message as string;
  const originalError = router.query.original_error as string;
  const correlationId = router.query.correlation_id as string;

  const error: AuthError | undefined = errorType
    ? {
        type: errorType,
        message: errorMessage,
        originalError: originalError,
        correlationId: correlationId,
      }
    : undefined;

  if (error) {
    newRelicNoticeError(new AuthenticationError(error));
  }

  const handleSignIn = () => {
    const stored = readPostAuthRedirect() ?? '/';
    signIn({ callbackUrl: stored });
  };

  const handleSignUp = () => {
    const stored = readPostAuthRedirect();
    router.push(stored ? `/signup?callbackUrl=${encodeURIComponent(stored)}` : '/signup');
  };

  const handleErrorOk = () => {
    router.push('/');
  };

  return (
    <>
      {error && (
        <UserNotFoundModal
          onClose={handleErrorOk}
          onSignIn={handleSignIn}
          onSignUp={handleSignUp}
          error={error}
          open={!!error}
        />
      )}
    </>
  );
};

export default AuthErrorPage;
